var $class="se2--content-blocks-grid--cards",$name="ContentBlocksGrid/cards",$path="app/components/ContentBlocksGrid/partials/cards/index.js",$this={$class,$name,$path,};import shell from 'app/modules/shell';

import isUsingKeyboard from 'app/utilities/isUsingKeyboard';

export default shell.registerComponent($this, ({
  addEventListener, mount,
}) => {
  const onLinkClick = ({ code, target }) => {
    if (isUsingKeyboard()) {
      if (code === 'Enter') {
        if (target.classList.contains('card-wrapper')) {
          const link = target.querySelector('.button');
          link.click();
        }
      }
    }
  };

  const setRoleToSlide = (slide) => {
    const links = slide.querySelectorAll('.button');
    slide.setAttribute('role', links.length ? 'link' : 'none');
  };

  mount((element) => {
    setRoleToSlide(element);
    addEventListener(element, 'keydown', onLinkClick);
  });
});
